export class TimeoutError extends Error {
	constructor(msg) {
		super(msg);
		this.name = "TimeoutError";
	}
}
